
import { computed, defineComponent, onBeforeMount, ref, watch } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";

import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { db } from "@/firebase/index";

// import Game from "@/types/Game";
import Player from "@/types/Player";

export default defineComponent({
  setup() {
    const route = useRoute();
    const gameData = ref<any>(null);
    const playerId = ref("");
    const showRole = ref(false);

    const steps = {
      wrwlf: "Night",
      dr: "Doctor",
      seer: "Seer",
      day: "Day",
    };

    const selectedPlayer = ref<Player | null>(null);

    const modifyPlayer = (action: string) => {
      if (selectedPlayer.value) {
        if (action == "kill") selectedPlayer.value.isAlive = false;
        if (action == "heal") selectedPlayer.value.isAlive = true;
        if (action == "reveal") selectedPlayer.value.reveal = true;
        closeActionsModal();
        updatePlayersArray();
      }
    };

    const updatePlayersArray = () => {
      const gameId = `${route.params.gameId}`;
      const gameRef = doc(db, "games", gameId);
      updateDoc(gameRef, {
        players: gameData.value.players,
      });
    };

    const updateGameStep = async () => {
      const order = "wrwlf_dr_seer_day";
      const orderArr = order.split("_");
      const currStep = gameData.value.step;
      const currStepIndex = orderArr.indexOf(currStep);
      let nextStep: number;
      if (currStepIndex + 1 > orderArr.length - 1) nextStep = 0;
      else {
        if (orderArr[currStepIndex + 1] == "seer" && !roleExists("seer")) {
          nextStep = currStepIndex + 2;
        } else nextStep = currStepIndex + 1;
      }
      const gameId = `${route.params.gameId}`;
      const gameRef = doc(db, "games", gameId);
      if (orderArr[nextStep] == "day") {
        gameData.value.players.forEach((player: Player) => {
          player.reveal = false;
        });
        updateDoc(gameRef, {
          players: gameData.value.players,
        });
      }
      updateDoc(gameRef, {
        step: orderArr[nextStep],
      });
    };

    const roleExists = (role: string) => {
      return gameData.value.players.find(
        (player: Player) => player.role == role
      );
    };

    const openActionsModal = (pid: string) => {
      let modal = document.getElementById("actionsModal");
      if (modal) modal.classList.add("is-active");

      const p = gameData.value.players.find(
        (player: Player) => player.pid == pid
      );
      selectedPlayer.value = p;
    };

    const closeActionsModal = () => {
      let modal = document.getElementById("actionsModal");
      if (modal) modal.classList.remove("is-active");
    };

    const myData = computed(() => {
      return gameData.value.players.find(
        (player: Player) => playerId.value == player.pid
      );
    });

    const watchGame = computed(() => {
      return gameData.value;
    });

    watch(watchGame, (newData, oldData) => {
      try {
        let countVllgrs = 0;
        let countWrwlvs = 0;
        newData.players.forEach((player: Player) => {
          if (player.role == "wrwlf" && player.isAlive) countWrwlvs++;
          if (
            player.role != "wrwlf" &&
            player.isAlive &&
            player.role != "mdrtr"
          )
            countVllgrs++;
        });
        if (countWrwlvs == 0 || countWrwlvs == countVllgrs) {
          if (countVllgrs == countWrwlvs) alert("Wrwlvs win!");
          if (countWrwlvs == 0) alert("Vllgrs win!");
          router.push("/");
        }
      } catch (err) {
        console.log("err");
      }
    });

    onBeforeMount(() => {
      const gameId = `${route.params.gameId}`;
      playerId.value = `${localStorage.getItem("wrwlfPid")}`;
      onSnapshot(doc(db, "games", gameId), (doc) => {
        gameData.value = doc.data();
        if (!myData.value) {
          alert("Game not joinable");
          router.push("/");
        }
      });
    });
    return {
      gameData,
      playerId,
      myData,
      steps,
      openActionsModal,
      closeActionsModal,
      selectedPlayer,
      modifyPlayer,
      updateGameStep,
      showRole,
    };
  },
});
